export const splitEmails = (value: string): string[] =>
  value
    // Normalize the input by trimming whitespace and splitting by common, semi-columns and space delimiters
    .split(/\s*[;, ]\s*/)
    .map((e) => e.trim())
    .filter((e) => e.length > 0);
